import { z } from 'zod';

export const sessionInfoSchema = z.object({
  id: z.string(),
  kind: z.enum(['device', 'delegated']),
  name: z.string(),
  created_at: z.string(),
  last_seen_at: z.string(),
  expires_at: z.string(),
  current: z.boolean(),
});

export type SessionInfo = z.infer<typeof sessionInfoSchema>;
